import { FunctionComponent, PropsWithChildren } from 'react'
import { Box, Container, Grid, ThemeProvider, useMediaQuery } from '@mui/material'
import { Header } from 'components/purchase/Header'
import { appPurchaseTheme } from 'theme'
import { Footer } from 'components/purchase/Footer'
import { BreadCrumb } from 'components/purchase/Breadcrumb'

interface Props extends PropsWithChildren {
  children?: React.ReactNode
  breadCrumbItems?: { title: string; path?: string; id?: string }[]
  content?: React.ReactNode
  maxWidth?: 'lg' | false
}

export const PurchaseLayout: FunctionComponent<Props> = ({
  breadCrumbItems,
  content,
  children,
  maxWidth = 'lg',
}) => {
  const isMobile = useMediaQuery('(max-width: 1200px)')

  return (
    <>
      <ThemeProvider theme={appPurchaseTheme}>
        <Header />
        <Box display="flex">
          <Box
            py={2}
            flexGrow="1"
            bgcolor={children ? '#fff' : '#F4F4F9'}
            sx={{
              backgroundClor: '#fafafb',
              paddingBottom: {
                xs: '60px',
                md: '120px',
              },
              minHeight: `calc(100vh - 465px)`,
            }}
          >
            {breadCrumbItems && (
              <Container maxWidth="lg" disableGutters={isMobile ? false : true}>
                <BreadCrumb items={breadCrumbItems} />
              </Container>
            )}
            <Container maxWidth={maxWidth} disableGutters={isMobile ? false : true}>
              {!children ? (
                <Grid columnSpacing={3} container>
                  <Grid xs={12} item>
                    {content}
                  </Grid>
                </Grid>
              ) : (
                children
              )}
            </Container>
          </Box>
        </Box>
        <Footer />
      </ThemeProvider>
    </>
  )
}
